import React from 'react';

export const NavLink = ({ href, label, active, onClick }) => (
    <a
        href={href}
        onClick={(e) => {
            e.preventDefault();
            onClick(href);
        }}
        className={`relative px-4 py-2 text-sm font-medium transition-colors duration-300 ${active ? 'text-[#d92323]' : 'text-[#7b7b7b] hover:text-white'
            }`}
    >
        {label}
        <span
            className={`absolute bottom-0 left-0 h-0.5 bg-[#d92323] transition-all duration-300 ${active ? 'w-full' : 'w-0'
                }`}
        />
    </a>
);

export const SectionTitle = ({ title, subtitle }) => (
    <div className="mb-12">
        <h2 className="text-4xl font-bold text-white mb-4 relative inline-block">
            {title}
            <span className="absolute -bottom-2 left-0 w-1/2 h-1 bg-[#d92323]"></span>
        </h2>
        {subtitle && <p className="text-[#7b7b7b] mt-4 max-w-2xl">{subtitle}</p>}
    </div>
);

export const LogoPlaceholder = ({ name }) => {
    const initials = name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();
    return (
        <div className="w-12 h-12 rounded-lg bg-[#1a1a1a] border border-[#732424]/30 flex items-center justify-center shrink-0 group-hover:border-[#d92323] transition-colors">
            <span className="text-[#d92323] font-bold font-mono">{initials}</span>
        </div>
    );
};